import { IO365ShellShim } from '@1js/suiteux-shell';
import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';

import { ObservableScope } from '../models/observable-scope.enum';
import { AngularEvents } from '../shared-context/angular-events';
import { AppEvent, EventService } from './event.service';
import { WindowService } from './window.service';

@Injectable({
    providedIn: 'root'
})
export class ShellShimService {
    public readonly afterShellRendered = this.onEventFired(AngularEvents.shellRendered);
    public readonly afterShellPlusLoaded = this.onEventFired(AngularEvents.shellPlusLoaded);

    constructor(
        private readonly windowService: WindowService,
        private readonly eventService: EventService
    ) {
    }

    public async getShellShim(): Promise<IO365ShellShim> {
        await this.afterShellRendered;
        return this.windowService.nativeWindow.O365Shell as IO365ShellShim;
    }

    private onEventFired(eventName: AngularEvents): Promise<AppEvent> {
        return this.eventService.events.withScope(ObservableScope.PastAndFuture).pipe(
            filter(event => event.name === eventName),
            take(1)
        ).toPromise();
    }
}
